var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoteLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.39996C1 7.77225 1 6.95839 1.44571 6.40799C1.53366 6.29938 1.63275 6.20028 1.74136 6.11233C2.29176 5.66663 3.10562 5.66663 4.73333 5.66663H9.71111C11.3388 5.66663 12.1527 5.66663 12.7031 6.11233C12.8117 6.20028 12.9108 6.29938 12.9987 6.40799C13.4444 6.95839 13.4444 7.77225 13.4444 9.39996V9.39996C13.4444 11.8415 13.4444 13.0623 12.7759 13.8879C12.644 14.0508 12.4953 14.1995 12.3324 14.3314C11.5068 15 10.286 15 7.84444 15H6.59999C4.15843 15 2.93764 15 2.11204 14.3314C1.94912 14.1995 1.80049 14.0508 1.66856 13.8879C1 13.0623 1 11.8415 1 9.39996V9.39996Z",
    stroke: "#BDBCBC",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 4.88889V4.11111C10.3333 2.39289 8.94041 1 7.2222 1V1C5.50398 1 4.11108 2.39289 4.11108 4.11111V4.88889",
    stroke: "#BDBCBC",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.2223,
    cy: 10.3334,
    r: 1.55556,
    fill: "#BDBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteLock);
export default __webpack_public_path__ + "static/media/vote_lock.6e166db87116497d8d73e48fbbc0a989.svg";
export { ForwardRef as ReactComponent };